import { render } from "./ProposalArgument.vue?vue&type=template&id=a929163a&scoped=true"
import script from "./ProposalArgument.vue?vue&type=script&lang=js"
export * from "./ProposalArgument.vue?vue&type=script&lang=js"

import "./ProposalArgument.vue?vue&type=style&index=0&id=a929163a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a929163a"]])

export default __exports__